import {Steps, Tree} from 'antd'
import {getType} from 'apis/model/base'
import classNames from 'classnames'
import EmptyHolder from 'components/EmptyHolder'
import getLinkToDetail from 'helpers/getLinkToDetail'
import _ from 'lodash'
import Translate from 'modules/local/Translate'
import useTranslate from 'modules/local/useTranslate'
import React, {useContext, useMemo} from 'react'
import {AiOutlineArrowRight} from 'react-icons/ai'
import {BsClipboardFill, BsRecordFill,} from 'react-icons/bs'
import {HiCode} from 'react-icons/hi'
import {Link} from 'react-router-dom'
import CodiDocumentContext, {CodiDocumentContentTypes,} from 'views/Document/CodiDocumentContext'
import LoadingPage from 'views/LoadingPage'
import {renderElse, renderIf, renderOwnChild} from 'views/Shared'
import {Responses} from '../../../Feed/Responses'
import CodiDocumentLinks from './CodiDocumentLinks'
import CodiSelectedRow from './CodiSelectedRow'
import {CodiSiderHeading, CodiSubHeader} from './CodiSiderHeading'
import {formatDate} from "../../../../helpers/datetimeHelpers";

const renderHistoryItems = (items = []) =>
    renderElse(
        _.isEmpty(items),
        <Translate>
            {(t) => (
                <Steps
                    size="small"
                    progressDot={true}
                    className="custom-step-history"
                    current={0}
                    direction="vertical">
                    {Array.from(items).map((item, i) => {
                        const {
                            id,
                            content,
                            eff_date,
                            end_date,
                            adding,
                            editing,
                            is_edited,
                            deleting,
                            is_deleted,
                            is_changed,
                            orig_document,
                        } = item

                        const adj_doc = _.get(item, 'adj_document_row')
                        const adj_note = _.get(item, 'adj_note')
                        const adj_url = _.get(item, 'adj_url')

                        const {
                            part_cd,
                            appendix_cd,
                            chapter_cd,
                            section_cd,
                            article_cd,
                            clause_cd,
                            point_cd,
                        } = adj_doc || {}

                        const is_original = !!!adj_doc

                        return (
                            <Steps.Step
                                key={id}
                                className="custom-step-codi p-1"
                                description={
                                    <div className="ml-1 text-color-300 text-xs italic">
                                        {!!!deleting ? content : null}
                                    </div>
                                }
                                title={
                                    <div
                                        key={i}
                                        style={{marginTop: i > 0 && '0.2rem'}}
                                        className="flex flex-col leading-3">
                                        <div className="flex flex-wrap flex-1 items-center gap-1 text-xs">
                      <span className="font-bold text-primary">
                        {formatDate(eff_date, 'DD/MM/YYYY')}
                      </span>
                                            <span style={{marginTop: '0.1rem'}}>
                        <AiOutlineArrowRight size={10}/>
                      </span>
                                            {end_date ? (
                                                <span className="font-semibold text-color-100">
                          {formatDate(end_date, 'DD/MM/YYYY')}
                        </span>
                                            ) : (
                                                <span className="font-medium text-color-000 ml-1">
                          {t('current')}
                        </span>
                                            )}
                                            {adding && (
                                                <span
                                                    className="px-2 py-1 ml-1 italic text-2xs font-semibold text-white bg-green-500 rounded-full">
                          {t('supplemented')}
                        </span>
                                            )}
                                            {editing && (
                                                <span
                                                    className="px-2 py-1 ml-1 italic text-2xs font-semibold text-white bg-primary rounded-full">
                          {t('amended')}
                        </span>
                                            )}
                                            {deleting && (
                                                <span
                                                    className="px-2 py-1 ml-1 italic text-2xs font-semibold text-white bg-red-400 rounded-full">
                          {t('annulled')}
                        </span>
                                            )}
                                        </div>
                                        {is_changed && (
                                            <div className="flex flex-col text-xs">
                                                {adj_doc ? (
                                                    <div className="font-semibold leading-4 italic my-1 gap-1">
                            <span className="pr-1 font-medium text-color-200">
                              {t('based on')}
                            </span>
                                                        <span className="text-color-000">
                              {_.map(
                                  [
                                      {label: article_cd, visible: !!article_cd},
                                      {
                                          label: `${
                                              clause_cd && t('clause')
                                          } ${clause_cd}`,
                                          visible: !!clause_cd,
                                      },
                                      {
                                          label: `${
                                              point_cd && t('point')
                                          } ${point_cd}`,
                                          visible: !!point_cd,
                                      },
                                  ].filter((e) => !!e.visible),
                                  'label'
                              ).join(', ')}{' '}
                                                            {' : '}
                            </span>
                                                        <Link
                                                            target="_blank"
                                                            to={getLinkToDetail(
                                                                _.get(adj_doc, 'ref_document')
                                                            )}
                                                            className="italic font-medium text-primary">
                                                            {_.get(adj_doc, 'ref_document.title')}
                                                        </Link>
                                                    </div>
                                                ) : (
                                                    adj_note && (
                                                        <span className="max-lines-2 mt-2 italic">
                              <span className="pr-1 font-medium text-color-200">
                                {t('based on')}
                              </span>
                              <a
                                  target="_blank"
                                  href={adj_url}
                                  className="font-semibold text-teal-500 no-underline">
                                {adj_note}
                              </a>
                            </span>
                                                    )
                                                )}
                                                {adding && (
                                                    <div className="font-semibold leading-4 italic my-1 gap-1">
                            <span className="pr-1 font-medium text-color-200">
                              {t('supplemented')}
                            </span>
                                                        <span className="text-color-000">
                              {_.map(
                                  [
                                      {
                                          label: _.get(item, 'article_cd'),
                                          visible: !!_.get(item, 'article_cd'),
                                      },
                                      {
                                          label: `${
                                              _.get(item, 'clause_cd') && t('clause')
                                          } ${_.get(item, 'clause_cd')}`,
                                          visible: !!_.get(item, 'clause_cd'),
                                      },
                                      {
                                          label: `${
                                              _.get(item, 'point_cd') && t('point')
                                          } ${_.get(item, 'point_cd')}`,
                                          visible: !!_.get(item, 'point_cd'),
                                      },
                                  ].filter((e) => !!e.visible),
                                  'label'
                              ).join(', ')}
                                                            {' : '}
                            </span>
                                                        <Link
                                                            target="_blank"
                                                            to={getLinkToDetail(_.get(item, 'orig_document'))}
                                                            className="italic font-medium text-primary">
                                                            {_.get(item, 'orig_document.title')}
                                                        </Link>
                                                    </div>
                                                )}
                                            </div>
                                        )}
                                        {!!is_original && (
                                            <div className="text-xs font-semibold leading-4 italic my-1 gap-1">
                        <span className="text-color-000">
                          {/*{_.map(*/}
                            {/*  [*/}
                            {/*    {*/}
                            {/*      label: _.get(item, 'article_cd'),*/}
                            {/*      visible: !!_.get(item, 'article_cd'),*/}
                            {/*    },*/}
                            {/*    {*/}
                            {/*      label: `${*/}
                            {/*        _.get(item, 'clause_cd') && t('clause')*/}
                            {/*      } ${_.get(item, 'clause_cd')}`,*/}
                            {/*      visible: !!_.get(item, 'clause_cd'),*/}
                            {/*    },*/}
                            {/*    {*/}
                            {/*      label: `${*/}
                            {/*        _.get(item, 'point_cd') && t('point')*/}
                            {/*      } ${_.get(item, 'point_cd')}`,*/}
                            {/*      visible: !!_.get(item, 'point_cd'),*/}
                            {/*    },*/}
                            {/*  ].filter((e) => !!e.visible),*/}
                            {/*  'label'*/}
                            {/*).join(', ')}{' '}{' : '}*/}
                            {[
                                _.get(item, 'short_index_name'),
                                !!_.get(item, 'short_index_name') ? ': ' : ' ',
                            ].join('')}
                        </span>
                                                <Link
                                                    target="_blank"
                                                    to={getLinkToDetail(_.get(item, 'orig_document'))}
                                                    className="italic font-medium text-primary">
                                                    {_.get(item, 'orig_document.title')}
                                                </Link>
                                            </div>
                                        )}
                                    </div>
                                }
                            />
                        )
                    })}
                </Steps>
            )}
        </Translate>
    )

const CodiArticleComments = ({
                                 item,
                                 header = null,
                                 Wrapper = renderOwnChild,
                             }) => {
    const [id, type] = [item?.id, getType(item)]

    return renderElse(
        _.isEmpty(item),
        <Wrapper>
            {header}
            <Responses {...{id, type, renderEmpty: () => <EmptyHolder/>}} />
        </Wrapper>
    )
}

export const CodiRowHistory = ({item: row_detail, isLoading = false}) => {
    const t = useTranslate()

    const createTreeData = (data = []) =>
        Array.from(data)
            .map((item) => {
                const {
                    content,
                    index_cd,
                    index_typecd,
                    children_rows = [],
                    history_items = [],
                } = item || {}

                const id = item?.id

                const isLeaf = _.isEmpty(children_rows)

                const next_rows = Array.from(children_rows)

                const title = (
                    <Translate>
                        {(t) => (
                            <div>
                                <div
                                    id={id}
                                    className="space-x-1 mb-1">
                  <span
                      className={classNames(
                          'text-color-000 text-sm',
                          index_typecd === CodiDocumentContentTypes.ARTICLE
                              ? 'font-bold'
                              : 'font-semibold'
                      )}>
                    {[
                        CodiDocumentContentTypes.CLAUSE,
                        CodiDocumentContentTypes.POINT,
                        CodiDocumentContentTypes.CHAPTER,
                    ].includes(index_typecd)
                        ? [t(index_typecd), index_cd].join(' ')
                        : index_cd}
                  </span>
                                    {renderIf(
                                        index_typecd !== CodiDocumentContentTypes.CONTENT,
                                        ': '
                                    )}
                                    <span
                                        className={classNames(
                                            index_typecd === CodiDocumentContentTypes.CONTENT &&
                                            _.isEmpty(index_cd)
                                                ? 'italic text-sm text-color-300 leading-tight'
                                                : 'text-sm'
                                        )}>
                    {index_typecd === 'content' && (
                        <BsRecordFill
                            size={8}
                            className="mr-1 text-color-400"
                        />
                    )}
                                        {content}
                  </span>
                                </div>
                                {renderHistoryItems(history_items)}
                            </div>
                        )}
                    </Translate>
                )

                return {
                    title,
                    isLeaf,
                    key: id,
                    data: item,
                    children: createTreeData(next_rows),
                }
            })
            .filter(Boolean)

    const content = useMemo(() => {
        if (_.isEmpty(row_detail)) {
            return null
        }
        const data = Array.from([row_detail])
        const treeData = createTreeData(data)
        const createHeader = (item) =>
            _.map(
                [
                    {
                        name: 'part_cd',
                        type: CodiDocumentContentTypes.PART,
                    },
                    {
                        name: 'appendix_cd',
                        type: CodiDocumentContentTypes.APPENDIX,
                    },
                    {
                        name: 'chapter_cd',
                        type: CodiDocumentContentTypes.CHAPTER,
                        renderLabel: ({type, value}) => `${value}`,
                    },
                    {
                        name: 'section_cd',
                        type: CodiDocumentContentTypes.SECTION,
                    },
                    {
                        name: 'article_cd',
                        type: CodiDocumentContentTypes.ARTICLE,
                    },
                    {
                        name: 'clause_cd',
                        type: CodiDocumentContentTypes.CLAUSE,
                        renderLabel: ({type, value}) => `${t(type)} ${value}`,
                    },
                    {
                        name: 'point_cd',
                        type: CodiDocumentContentTypes.POINT,
                        renderLabel: ({type, value}) => `${t(type)} ${value}`,
                    },
                ]
                    .map(
                        ({
                             name,
                             type,
                             renderLabel = ({type, value}) => value,
                             ...rest
                         }) => {
                            const value = _.get(item, name)
                            return {
                                ...rest,
                                value,
                                invisible: type === _.get(item, 'index_typecd'),
                                label: renderLabel({
                                    type,
                                    value,
                                }),
                            }
                        }
                    )
                    .filter(({value, invisible = false}) => {
                        if (invisible) {
                            return false
                        }
                        return value && !_.isEmpty(value)
                    }),
                'label'
            ).join(', ')

        const header_meta = createHeader(row_detail)

        return renderElse(
            _.isEmpty(treeData),
            <div>
                {renderElse(
                    _.isEmpty(header_meta),
                    <div className="flex flex-wrap font-semibold text-sm text-color-000">
                        {header_meta}
                    </div>
                )}
                {_.get(row_detail, 'is_html') === true ? (
                    <div className="flex flex-col flex-center gap-1 py-3 background-100 rounded-lg mt-2">
                        <HiCode
                            size={30}
                            className="text-color-400"
                        />
                        <span className="text-xs text-color-500 italic">
              {t('here is the HTML code')}
            </span>
                    </div>
                ) : (
                    <Tree
                        style={
                            _.isEmpty(header_meta)
                                ? {
                                    marginLeft: -14,
                                }
                                : undefined
                        }
                        selectable={false}
                        treeData={treeData}
                        className="less-space"
                        defaultExpandAll={true}
                    />
                )}
            </div>
        )
    }, [row_detail])

    if (isLoading) {
        return <LoadingPage/>
    }

    return (
        <React.Fragment>
            {!!_.get(row_detail, 'is_changed') ? (
                <div className="timeline-group-header flex flex-col gap-2">
                    {content}
                </div>
            ) : (
                <EmptyHolder/>
            )}
        </React.Fragment>
    )
}

const CodiDocumentTimeLine = ({style, className, Wrapper = 'div'}) => {
    const {item, storage} = useContext(CodiDocumentContext)
    const t = useTranslate()

    const {
        selected_item,
        row_detail = {},
        isLoading = false,
        root_selected,
    } = storage || {}

    const createTreeData = (data = []) =>
        Array.from(data)
            .map((item) => {
                const {
                    content,
                    index_cd,
                    index_typecd,
                    children_rows = [],
                    history_items = [],
                } = item || {}

                const id = item?.id

                const isLeaf = _.isEmpty(children_rows)

                const next_rows = Array.from(children_rows)

                const title = (
                    <Translate>
                        {(t) => (
                            <div>
                                <div
                                    id={id}
                                    className="space-x-1 mb-1">
                  <span
                      className={classNames(
                          'text-color-000 text-sm',
                          index_typecd === CodiDocumentContentTypes.ARTICLE
                              ? 'font-bold'
                              : 'font-semibold'
                      )}>
                    {[
                        CodiDocumentContentTypes.CLAUSE,
                        CodiDocumentContentTypes.POINT,
                        CodiDocumentContentTypes.CHAPTER,
                    ].includes(index_typecd)
                        ? [t(index_typecd), index_cd].join(' ')
                        : index_cd}
                  </span>
                                    <span
                                        className={classNames(
                                            index_typecd === CodiDocumentContentTypes.CONTENT &&
                                            _.isEmpty(index_cd)
                                                ? 'italic text-sm text-color-300 leading-tight'
                                                : 'text-sm'
                                        )}>
                    {index_typecd === 'content' && (
                        <BsRecordFill
                            size={8}
                            className="mr-1 text-color-400"
                        />
                    )}
                                        {content}
                  </span>
                                </div>
                                {renderHistoryItems(history_items)}
                            </div>
                        )}
                    </Translate>
                )

                return {
                    title,
                    isLeaf,
                    key: id,
                    data: item,
                    children: createTreeData(next_rows),
                }
            })
            .filter(Boolean)

    const content = useMemo(() => {
        if (_.isEmpty(row_detail)) {
            return null
        }
        const data = Array.from([row_detail])
        const treeData = createTreeData(data)
        const createHeader = (item) =>
            _.map(
                [
                    {
                        name: 'part_cd',
                        type: CodiDocumentContentTypes.PART,
                    },
                    {
                        name: 'appendix_cd',
                        type: CodiDocumentContentTypes.APPENDIX,
                    },
                    {
                        name: 'chapter_cd',
                        type: CodiDocumentContentTypes.CHAPTER,
                        renderLabel: ({type, value}) => `${value}`,
                    },
                    {
                        name: 'section_cd',
                        type: CodiDocumentContentTypes.SECTION,
                    },
                    {
                        name: 'article_cd',
                        type: CodiDocumentContentTypes.ARTICLE,
                    },
                    {
                        name: 'clause_cd',
                        type: CodiDocumentContentTypes.CLAUSE,
                        renderLabel: ({type, value}) => `${t(type)} ${value}`,
                    },
                    {
                        name: 'point_cd',
                        type: CodiDocumentContentTypes.POINT,
                        renderLabel: ({type, value}) => `${t(type)} ${value}`,
                    },
                ]
                    .map(
                        ({
                             name,
                             type,
                             renderLabel = ({type, value}) => value,
                             ...rest
                         }) => {
                            const value = _.get(item, name)
                            return {
                                ...rest,
                                value,
                                invisible: type === _.get(item, 'index_typecd'),
                                label: renderLabel({
                                    type,
                                    value,
                                }),
                            }
                        }
                    )
                    .filter(({value, invisible = false}) => {
                        if (invisible) {
                            return false
                        }
                        return value && !_.isEmpty(value)
                    }),
                'label'
            ).join(', ')

        const header_meta = createHeader(row_detail)

        const is_content = _.get(row_detail, 'index_typecd') === 'content'

        return renderElse(
            _.isEmpty(treeData),
            <div>
                {renderElse(
                    _.isEmpty(header_meta),
                    <div className="font-semibold text-sm text-color-000">
                        {header_meta}
                        {' : '}
                        {is_content && (
                            <span className="text-color-100 italic">
                {_.get(row_detail, 'index_content')}
              </span>
                        )}
                    </div>
                )}
                {Boolean(_.get(row_detail, 'is_html')) ? (
                    <div className="flex flex-col flex-center gap-1 py-3 background-100 rounded-lg mt-2">
                        <HiCode
                            size={30}
                            className="text-color-400"
                        />
                        <span className="text-xs text-color-500 italic">
              {t('here is the HTML code')}
            </span>
                    </div>
                ) : (
                    <Tree
                        style={
                            _.isEmpty(header_meta)
                                ? {
                                    marginLeft: -14,
                                }
                                : undefined
                        }
                        treeData={treeData}
                        className="less-space"
                        defaultExpandAll={true}
                    />
                )}
            </div>
        )
    }, [row_detail])

    return (
        <Wrapper
            style={style}
            className={classNames('flex flex-col', className)}>
            <CodiSiderHeading
                title="content details"
                icon={
                    <BsClipboardFill
                        size={20}
                        className="text-primary"
                    />
                }
            />
            <div className="flex flex-col gap-6">
                {selected_item && <CodiSelectedRow/>}
                {!!_.get(selected_item, 'is_changed') &&
                renderElse(
                    _.isEmpty(row_detail),
                    <div className="timeline-group-header flex flex-col gap-2">
                        <CodiSubHeader
                            title={
                                <span className="flex gap-1">
                    {`${_.capitalize(t('amended'))}, ${_.capitalize(
                        t('supplemented')
                    )}, ${_.capitalize(t('annulled'))}`}
                  </span>
                            }
                        />
                        {isLoading ? <LoadingPage/> : content}
                    </div>
                )}
                <React.Fragment>
                    <CodiDocumentLinks/>
                    <div className="timeline-group-header">
                        <CodiArticleComments
                            item={!!root_selected ? item : selected_item}
                        />
                    </div>
                </React.Fragment>
            </div>
        </Wrapper>
    )
}

export default CodiDocumentTimeLine
